import React from 'react';
import {Button} from "presentation/common";
import clsx from "clsx";
import logo from './logo.svg';

import styles from './site.module.scss';

export const Site = ({className, children, title, subTitle, message, href}) => {

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.topContainer}>
        {children}
        <img src={logo} alt="logo" className={styles.logo}/>
        <h4>{title}</h4>
        <p className="message">{subTitle}</p>
      </div>
      <div>{message}</div>
      <Button label="Acceder" onClick={() =>  window.open(href, '_blank')}/>
    </div>
  );
};
